import React from 'react';
import { BarChart2 } from 'lucide-react';
export function SurveyParticipationWidget() {
  // Mock data
  const surveyData = {
    title: 'Pulse bien-être Q4 2023',
    endDate: '18 nov. 2023',
    totalEmployees: 12,
    participationRate: 75,
    averageScore: 4.2
  };
  return <div className="bg-white rounded-lg shadow-sm p-5" data-id="element-2087">
      <div className="flex items-center justify-between mb-4" data-id="element-2088">
        <h3 className="font-semibold text-gray-900" data-id="element-2089">Sondage en cours</h3>
        <BarChart2 className="h-5 w-5 text-blue-600" data-id="element-2090" />
      </div>
      <div className="mb-4" data-id="element-2091">
        <p className="font-medium text-gray-900" data-id="element-2092">{surveyData.title}</p>
        <p className="text-sm text-gray-600" data-id="element-2093">Fermeture: {surveyData.endDate}</p>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-2094">
        <div className="bg-blue-50 p-3 rounded text-center" data-id="element-2095">
          <span className="block text-xl font-semibold text-blue-600" data-id="element-2096">
            {surveyData.participationRate}%
          </span>
          <span className="text-xs text-blue-800" data-id="element-2097">Participation</span>
        </div>
        <div className="bg-green-50 p-3 rounded text-center" data-id="element-2098">
          <span className="block text-xl font-semibold text-green-600" data-id="element-2099">
            {surveyData.averageScore}/5
          </span>
          <span className="text-xs text-green-800" data-id="element-2100">Score moyen</span>
        </div>
      </div>
      <div className="text-sm text-gray-600 mb-4" data-id="element-2101">
        <span className="font-medium" data-id="element-2102">
          {Math.round(surveyData.totalEmployees * surveyData.participationRate / 100)}
        </span>{' '}
        sur <span className="font-medium" data-id="element-2103">{surveyData.totalEmployees}</span>{' '}
        employés ont répondu
      </div>
      <div className="flex justify-between" data-id="element-2104">
        <button className="px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50" data-id="element-2105">
          Rappel
        </button>
        <button className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700" data-id="element-2106">
          Voir résultats
        </button>
      </div>
    </div>;
}